module.exports = __webpack_public_path__ + "img/sequire-light.f9c4a2de.svg";